import { KoyouKeiyakuTime } from "./KoyouKeiyaku";

export interface SyuugyouJoukenMeijisyoRes {
    meijisyo: SyuugyouJoukenMeijisyo | null
}

export class SyuugyouJoukenMeijisyo {
    syuugyou_jouken_meijisyo_id: number | null = null
    koyou_keiyaku_id: number | null = null
    koyou_keiyaku: MeijisyoKoyouKeiyakuData | null = null
    syuugyou_basyo_name: string | null = null
    syuugyou_basyo_busyo_name: string | null = null
    soshiki_tanni: string | null = null
    kyuukei_start: string | null = null // 休憩時間の開始
    kyuukei_end: string | null = null
    kyuukei_total: string | null = null
    shikimeirei_busyo: string | null = null
    shikimeirei_tel: string | null = null
    shikimeirei_yakusyoku: string | null = null
    shikimeirei_shimei: string | null = null
    hakensaki_saisyono: string | null = null
    soshikitani_saisyonohi: string | null = null
    hakensaki_sekininsya_busyo: string | null = null
    hakensaki_sekininsya_tel: string | null = null
    hakensaki_sekininsya_yakusyoku: string | null = null
    hakensaki_sekininsya_shimei: string | null = null
    hakenmoto_sekininsya_busyo: string | null = null
    hakenmoto_sekininsya_tel: string | null = null
    hakenmoto_sekininsya_yakusyoku: string | null = null
    hakenmoto_sekininsya_shimei: string | null = null
    hakensaki_moushidesaki_busyo: string | null = null
    hakensaki_moushidesaki_tel: string | null = null
    hakensaki_moushidesaki_yakusyoku: string | null = null
    hakensaki_moushidesaki_shimei: string | null = null
    hakenmoto_moushidesaki_busyo: string | null = null
    hakenmoto_moushidesaki_tel: string | null = null
    hakenmoto_moushidesaki_yakusyoku: string | null = null
    hakenmoto_moushidesaki_shimei: string | null = null
    kujou: string | null = null
    anzen: string | null = null
    fukushi_zoushin: string | null = null
    syoukaiyoteihaken: string | null = null
    roudouhaken_ryoukin: string | null = null
    koyou_riyuu: string | null = null
    kenkouhoken_riyuu: string | null = null
    kouseinenkin_riyuu: string | null = null
    haken_koyou_sochi: string | null = null
    hakensaki_funsouboushi_sochi: string | null = null
}

export interface MeijisyoKoyouKeiyakuData {
    kana: string | null
    keiyaku_date: string | null
    koyou_end_date: string | null
    koyou_keiyaku_id: number
    name: string | null
    // mst_syuugyou_basyo_id: number
    syuugyou_basyo_address: string | null
    // syuugyou_basyo_name: string | null
    syuugyou_basyo_tel: string | null
    user_id: number
    work_detail1: string | null
    work_detail2: string | null
    koyou_keiyaku_times: KoyouKeiyakuTime[]
}

export interface MeijisyoInfoForTimeSheet {
    syuugyou_jouken_meijisyo_id: number
    koyou_keiyaku_id: number
    syuugyou_basyo_name: string | null
    syuugyou_basyo_busyo_name: string | null
    soshiki_tanni: string | null
    work_detail1: string | null
    work_detail2: string | null
}